import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { SwUpdateService, SystemCheckService } from '@ic-monorepo/shared-services';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';

@UntilDestroy()
@Component({
  standalone: true,
  selector: 'ic-shell',
  templateUrl: './shell.page.html',
  imports: [ButtonModule, MessageModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellPageComponent {
  systemCheckService = inject(SystemCheckService);
  swUpdateService = inject(SwUpdateService);

  /** When true, suppresses the SwUpdate "refresh the page" banner.
   *  Used to avoid wiping in-memory patient submission state on reload. */
  readonly hideUpdateBanner = input(false);

  reloadPage(): void {
    this.swUpdateService.forceCleanCache();
  }
}
